<template lang="pug">
  .container.grid-xl
    page-title(title="Planos" icon="fas fa-shapes" subtitle="Planos para seus assinantes")
      div(slot="actions")
        router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
          :to="{ name: 'plans.list.filter', query: $route.query }"
          data-tooltip="Filtrar"
        )
          i.fas.fa-filter
          span.badge(v-if="Boolean($route.query.q)")
        router-link.btn.btn-error(:to="{ name: 'plans.create' }")
          i.fas.fa-plus
          span &nbsp;Adicionar
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      .columns(v-if="list")
        .column.col-4.col-lg-6.col-sm-12.mb-2.pb-2(v-for="plan in list.rows")
          row(
            :plan="plan"
            @activate="onActivate"
            @deactivate="onDeactivate"
            @remove="onRemove"
          )
    router-view
</template>

<script>
import plans from '@/services/plans'
import Row from './components/Row'

export default {
  data() {
    return { loading: false, error: null, list: null }
  },
  components: { Row },
  watch: {
    '$route.query.q'() {
      const params = this.$route.query
      this.fetchData(params)
    },
  },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await plans.list({ ...params })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    async onRemove(plan) {
      const options = {
        size: 'sm',
        title: 'Confirmar exclusão',
        okLabel: 'Remover',
        cancelLabel: 'Cancelar',
      }
      const { ok } = await this.$dialogs.confirm(
        `Deseja remover ${plan.title}?`,
        options,
      )

      if (!ok) return

      try {
        await plans.destroy(plan.id)
        const params = this.$route.query
        await this.fetchData(params)
        this.$toaster.success(`${plan.title} removido`)
      } catch (e) {
        this.$toaster.error(`Não foi possível remover ${plan.title}`)
      }
    },
    async onActivate(plan) {
      const options = {
        size: 'sm',
        title: 'Confirmar ativação',
        okLabel: 'Ativar',
        cancelLabel: 'Cancelar',
      }
      const { ok } = await this.$dialogs.confirm(
        `Deseja ativar ${plan.title}?`,
        options,
      )

      if (!ok) return

      try {
        await plans.activate(plan.id)
        const params = this.$route.query
        await this.fetchData(params)
        this.$toaster.success(`${plan.title} ativado`)
      } catch (e) {
        this.$toaster.error(`Não foi possível ativar ${plan.title}`)
      }
    },
    async onDeactivate(plan) {
      const options = {
        size: 'sm',
        title: 'Confirmar inativação',
        okLabel: 'Inativar',
        cancelLabel: 'Cancelar',
      }
      const { ok } = await this.$dialogs.confirm(
        `Deseja inativar ${plan.title}?`,
        options,
      )

      if (!ok) return

      try {
        await plans.deactivate(plan.id)
        const params = this.$route.query
        await this.fetchData(params)
        this.$toaster.success(`${plan.title} inativado`)
      } catch (e) {
        this.$toaster.error(`Não foi possível inativar ${plan.title}`)
      }
    },
  },
  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
</script>
